// extracted by mini-css-extract-plugin
export default {"container":"CreateNoteModal_container__38pJx","titleContainer":"CreateNoteModal_titleContainer__GS73s","createNoteButton":"CreateNoteModal_createNoteButton__br9lp"};